module.exports = __webpack_public_path__ + "static/media/triangle-big.c251c9d0.svg";